import {actions as A} from '../constants/actions';

const defaultState = {
  citiesList: {
    list: null,
    loading: false,
    error: false,
    errorMessage: null
  },
  streetsList: {
    list: null,
    loading: false,
    error: false,
    errorMessage: null
  },
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.GET_TAB_CITIES:
      return {...state, citiesList: {...state.citiesList, loading: true, list: null}};

    case A.GET_TAB_CITIES_SUCCESS:
      return {...state, citiesList: {...state.citiesList, loading: false, list: payload}};

    case A.GET_TAB_CITIES_FAILURE:
      return {...state, citiesList: {...state.citiesList, loading: false, error: true, errorMessage: payload.errorMessage}};

    case A.GET_TAB_STREETS:
      return {...state, streetsList: {...state.streetsList, loading: true, list: null}};

    case A.GET_TAB_STREETS_SUCCESS:
      return {...state, streetsList: {...state.streetsList, loading: false, list: payload}};

    case A.GET_TAB_STREETS_FAILURE:
      return {...state, streetsList: {...state.streetsList, loading: false, error: true, errorMessage: payload.errorMessage}};

    case A.CLEAR_INSPECTION:
      return {...defaultState};

    default:
      return state;
  }
}
